import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { TransformSection } from '../components/TransformSection';
import { KitContentsSection } from '../components/KitContentsSection';
import { ResultsSection } from '../components/ResultsSection';
import { BeforeAfterSection } from '../components/BeforeAfterSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
export function LandingPage() {
  return <main className="w-full overflow-hidden" data-id="element-183">
      <HeroSection data-id="element-184" />
      <ProblemSection data-id="element-185" />
      <TransformSection data-id="element-186" />
      <KitContentsSection data-id="element-187" />
      <ResultsSection data-id="element-188" />
      <BeforeAfterSection data-id="element-189" />
      <OfferSection data-id="element-190" />
      <GuaranteeSection data-id="element-191" />
      <FinalCtaSection data-id="element-192" />
    </main>;
}